import Insight from "../insightClass";
import React from "react";
import { insight40Media } from "../../../assets/assetReference";
import { ContactSubscribe } from "../../../components/Contact/Contact";
export const insight071 = new Insight(
  "10 October 2025",
  {
    pageTitle: "Global Offshore Wind Weekly",
    metaDescription: "WeBridge Insights, Global Offshore Wind Weekly",
    keyWords:
      "European Offshore Wind Market development, Global Offshore Wind Weekly",
  },
  {
    src: insight40Media[0],
    alt: "offshore wind turbine",
  },
  "Global Offshore Wind Weekly (2025-10-10)",
  "",
  `Ørsted announced it will cut ~2,000 roles (c.25% of staff) by end-2027 as it retools the business after a bruising period—rights issue completed this week (~$9bn), US setbacks, and a tightened focus on offshore wind in core European/APAC markets. The restructuring targets DKK 2bn in annual savings from 2028 and follows a pause on a major UK project and exits from two US projects.`,
  <div>
    <strong>WeBridge Insights</strong>
    <h1>Global Offshore Wind Weekly (2025-10-10)</h1>
    <h2></h2>
    <p className="article-date">10 October 2025</p>
    <br />
    <p>
      Welcome to this week's <i>WeBridge Insights</i>, where we provide you with
      the latest updates and key developments from the global offshore wind
      market.
    </p>
    <br />
    <br />
    <br />
    <p>
      At <b>WeBridge</b>, we deliver forward-thinking analysis and expert
      commentary to keep you informed in this fast-evolving industry. Here's our
      roundup of the top stories this week, complete with professional insights
      to help you stay ahead:
    </p>
    <h3>1. Ørsted slashes workforce by 25% and pivots back to Europe</h3>
    <p>
      Ørsted announced it will cut ~2,000 roles (c.25% of staff) by end-2027 as
      it retools the business after a bruising period—rights issue completed
      this week (~$9bn), US setbacks, and a tightened focus on offshore wind in
      core European/APAC markets. The restructuring targets DKK 2bn in annual
      savings from 2028 and follows a pause on a major UK project and exits from
      two US projects. Management frames the move as aligning resources to
      deliver the current 8.1 GW offshore construction pipeline while stepping
      back from capital-intensive adjacencies (including a sale of European
      onshore). Markets reacted cautiously positive. 
    </p>
    <p>
      <b>WeBridge Insights:</b>
    </p>
    <p>
      This is the clearest signal yet that “pure-play offshore” is back in vogue
      for Ørsted—and likely for peers. Expect knock-on effects across the UK
      supply chain: tendering calendars could compress (fewer, larger packages),
      and frame agreements may supersede lots-based sourcing to lock cost and
      schedule. UK counterparties should brace for tougher
      availability/liquidated damages positions and tighter credit wraps as
      developers protect balance sheets. For OEMs and Tier-2s, a smaller but
      more decisive buyer could actually accelerate FIDs where policy risk is
      lowest (North Sea, Baltics), but EPC wrap appetite will remain thin until
      rates normalise and US policy risks recede.
    </p>
    <h3>
      2. Lithuania’s 700 MW offshore tender declared invalid after only one bid
    </h3>
    <p>
      Lithuania’s second 700 MW offshore wind tender was deemed invalid after
      the application window closed with just one bidder, following a September
      suspension intended to boost participation. Authorities (VERT/NERC)
      confirmed the result on 8 Oct. The stop-start process—summer launch,
      September pause, 6–7 Oct resumption—exposed fragilities in auction design
      and market readiness. Local utility Ignitis confirmed it submitted a bid;
      lack of a second entrant tripped the legal requirement for competition.
      The episode lands as several EU markets reevaluate auction design (moving
      away from negative bidding, adding CfD elements, adjusting grid/offtake
      risk). 
    </p>
    <p>
      <b>WeBridge Insights:</b>
    </p>
    <p>Three takeaways for Baltic developers and policymakers:</p>
    <ol>
      <li>
        <b>Calendar discipline matters</b> — short, split bidding windows deter
        global players juggling multiple tenders.
      </li>
      <li>
        <b>Bankability over headline capacity</b> — grid timing, route-to-market
        clarity (PPA vs CfD), and inflation indexation will make or break
        participation.
      </li>
      <li>
        <b>Regional stacking</b> — coordinating with Poland, Latvia and Estonia
        to avoid “tender bunching” could deepen the bidder pool.
      </li>
    </ol>
    <p>
      For supply chain, the near-term impact is neutral-to-negative (delayed
      cabling/foundation orders), but a rapid relaunch with CfD-like revenue
      stabilisers and clear cable/landfall milestones could still see 2026 FID.
      Corporate buyers in the Baltics should watch for expanded hybrid (PPA +
      CfD) constructs that stabilise merchant exposure while preserving state
      budget discipline.
    </p>
    <h3>3. Jan De Nul taps Tekmar for German cable protection framework</h3>
    <p>
      Jan De Nul awarded Tekmar Group a framework to supply cable protection
      systems for a large German offshore wind programme. Tekmar indicated the
      scope covers manufacture and supply, with further details to follow; the
      agreement underscores continuing grid/export-system spend even as some
      generation tenders falter. Germany’s market has seen uneventful H1 2025
      grid-connect stats and recent auction hiccups, heightening the importance
      of execution on transmission/cabling to unlock build-out. 
    </p>
    <p>
      <b>WeBridge Insights:</b>
    </p>
    <p>
      In a margin-tight world, sub-sea balance-of-plant is where schedule risk
      often crystallises. Frameworks like this can take 5–10% out of installed
      cable cost through standardised CPS designs, pre-qualification, and volume
      pricing—while de-risking interfaces among OEMs, T&I contractors, and TSOs.
      For German projects targeting 2028–2031 CODs, locking CPS and cable
      accessories early is prudent given resin/steel volatility and constrained
      factory slots. UK suppliers should note: German grid timetables are
      increasingly dictating turbine package mobilisation; similar dynamics will
      shape UK AR7 winners’ procurement sequencing (cables and substations
      first, turbines second).
    </p>
    <h3>
      4. Ørsted says Sunrise Wind still targets H2 2027; Revolution Wind back on
      track
    </h3>
    <p>
      Ørsted reaffirmed that US project Sunrise Wind remains targeted for H2
      2027 COD. Revolution Wind—about 80% complete—has restarted following the
      lifting of a federal work-stop order; operations are now expected in H2
      2026. Against a volatile US policy backdrop, these updates suggest Ørsted
      will finish what’s farthest along while trimming optionality elsewhere. 
    </p>
    <p>
      <b>WeBridge Insights:</b>
    </p>
    <p>
      For OEMs, port operators, and vessel owners, resumed execution on
      Revolution de-clogs near-term US utilisation. The more important signal
      for UK/Europe is portfolio triage discipline: European yards and suppliers
      could see fewer US-destined change orders as Ørsted freezes specs to hit
      Sunrise’s 2027 window. We expect US-linked risks (Jones Act vessel
      availability, BOEM permitting cadence) to continue feeding through to EU
      capacity planning—creating intermittent windows for UK/EU projects to pull
      forward slots if they are genuinely “shovel-ready” with robust offtake.
      Developers eyeing trans-Atlantic supply chains should ring-fence
      contingency for policy-driven work-stops and consider dual-sourcing
      CPS/array cables to hedge.
    </p>
    <h3>
      5. IEA trims global renewables outlook amid US policy turbulence and China
      auction reforms
    </h3>
    <p>
      The International Energy Agency pared back its near-term renewables
      deployment outlook this week, citing US policy shifts and evolving Chinese
      auction designs that weigh on investment certainty. While not
      offshore-specific, the read-through is material: capital costs stay
      elevated, and auction frameworks are in flux, reinforcing developers’
      shift to fewer, de-risked markets and projects with clearer revenue
      floors. 
    </p>
    <p>
      <b>WeBridge Insights:</b>
    </p>
    <p>
      Financing is now the primary lever. For UK AR7 and North Sea auctions,
      expect higher equity hurdle rates baked into bids unless indexation and
      curtailment protections improve. On the supply side, OEM recovery remains
      uneven; service revenues and upgrades are cushioning balance sheets, but
      newbuild turbine pricing will stay firm. Our base case: 2026–27 sees an
      uptick in FIDs concentrated in markets offering CfDs or two-way premium
      PPAs with caps/floors (UK, DE—post-reform, NL—post-reset). Corporate PPAs
      will skew to shorter tenors with collar structures to navigate price
      cannibalisation and negative price clauses.
    </p>
    <h3>
      6. Japan designates two “promising zones” for offshore wind (Akita,
      Fukuoka)
    </h3>
    <p>
      Japan named two new “promising areas” for future offshore wind development
      off Akita and Fukuoka. The designation is a gate-opener to detailed
      surveys and formal auctioning and follows the government’s staged approach
      to maturing sites before tenders. The move comes as Japan continues to
      recalibrate after cost spikes and grid constraints challenged earlier
      rounds. 
    </p>
    <p>
      <b>WeBridge Insights:</b>
    </p>
    <p>
      For European suppliers, Japan remains a premium-margin, low-volume play
      where localisation and port logistics drive bid strategy. The immediate
      opportunities are pre-FID: site investigation, metocean, geotech, and
      early cable routing. UK consultancies can win here by pairing bankable
      LCOE modelling with consenting know-how and cyclone-resilience design.
      Expect consortiums to emphasise floating-ready designs in Kyushu waters
      and leverage Akita’s fixed-bottom track record. Currency risk (JPY
      volatility) and EPC inflation pass-throughs will be front-and-centre in
      bid economics; we recommend early FX hedging and contracts with
      transparent escalation indices.
    </p>
    <h3>7. Jan De Nul to install export cables for Taiwan’s Formosa 4</h3>
    <p>
      Synera Renewable Energy picked Jan De Nul to transport, install and
      protect ~60 km (c.37 mi) of export cables for the Formosa 4 project in
      Taiwan, with works slated to start next year and conclude in 2027. The
      award underscores steady momentum in Taiwan’s next wave despite global
      cost pressures, with international T&I houses continuing to anchor complex
      scopes. 
    </p>
    <p>
      <b>WeBridge Insights:</b>
    </p>
    <p>
      Cable export scopes in Taiwan are an execution-risk hotspot (typhoons,
      seabed mobility, fishing interactions). We expect robust burial depth
      strategies, dynamic route engineering, and enhanced monitoring (DTS/DAS)
      to be priced in. For UK/European suppliers, Taiwan remains a critical
      diversification market—particularly for vessels and high-spec CPS—though
      project finance often demands stronger step-in rights and political risk
      cover. With Formosa 4 timelines overlapping with European 2026–27 peaks,
      capacity juggling will intensify; UK developers should secure contingency
      slots early or explore staggered array-to-export interfaces to avoid
      bottlenecks.
    </p>

    <br />
    <br />
    <br />
    <p>
      As the global offshore wind sector continues to advance, innovation,
      investments, and supportive policies are driving transformative growth. At{" "}
      <i>
        <b>WeBridge</b>
      </i>
      , we provide the expertise and insights our partners need to confidently
      navigate this evolving landscape.
    </p>
    <h3 style={{ marginTop: "200px" }}>Subscribe</h3>
    <ContactSubscribe />
  </div>,
);
